import React from 'react';
import ModalModule from '../modal';

const { Modal, ModalButtonActionType } = ModalModule;

const ConfirmTransactionModal = ({ modalId, data: { purchaseAmount } }) => (
	<Modal
		modalId={modalId}
		className="common-payment confirm-transaction-modal"
		header="Confirm Transaction"
		primaryButton={{
			text: 'Confirm',
			type: ModalButtonActionType.Confirm,
		}}
	>
		{`Please confirm that you wish to add ${purchaseAmount} to your account balance. Once you
		click the Confirm button, the amount will be added to your account and cannot be refunded.`}
	</Modal>
);

export default ConfirmTransactionModal;
